import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  input,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FormsModule],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
    },
  ],
  selector: 'aux-checkbox',
  styleUrls: ['./checkbox.component.scss'],
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  pendoTag = input<string>('');

  @Input() checked = false;
  @Output() customChange = new EventEmitter<boolean>();
  @Input() disabled = false;
  @Input() editMode: boolean | undefined = undefined;
  @Input() hideLabel: boolean | undefined = false;
  @Input() hideLabelCursor: boolean | undefined = undefined;
  @Input() id = '';
  @Input() indeterminate = false;
  onChangeCallback?: (p: boolean) => void;
  onTouchedCallback?: () => void;

  registerOnChange(fn: (p: boolean) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  writeValue(value: boolean): void {
    this.checked = value;
    this.cdr.detectChanges();
  }
}
